import { getData } from "./apiUtils";
import * as CONFIG from '../utils/config'


export function getAllFieldTypes() {
    return getData(CONFIG.GET_ALL_FIELD_TYPES_URL());
}
